export default {
  assistant: {
    error: "处理您的消息时遇到技术问题。请稍后再试。",
    inputPlaceholder: "输入您的消息...",
    title:"智能助手",
    welcome: "您好！我是您的数字旅行助手。我在这里通过协助您的旅行计划和行程安排，让您的旅途更加愉快。请随时将您的行程详情发送给我，我目前尚无法访问这些信息。我今天可以为您做些什么？"
  },
  common: {
    save: "保存更改",
    cancel: "取消",
    saving: "保存中...",
    updating: "更新中...",
    back: "返回",
    traveler: "旅行者",
    success: "成功",
    error: "錯誤",
    deleting: "刪除中...",
    toast: {
      success: "成功！",
      error: "錯誤",
      info: "信息",
      warning: "警告",
      copied: "已複製到剪貼板",
      saved: "更改已保存",
      deleted: "已成功刪除",
      updated: "已成功更新"
    },
    cabinClass: "客舱等级",
    bookingReference: "预订参考号",
    confirmationNumbers: "确认号码",
    in: "在"
  },
  auth: {
    signOut: "登出",
    signOutSuccess: "已成功登出",
    redirectingHome: "正在重定向到首頁...",
    loginWithEmail: "邮箱登录",
    createAccount: "创建账户",
    welcomeBack: "欢迎回来",
    enterEmailForCode: "输入您的邮箱以接收一次性验证码",
    signUpToManageTrips: "注册以开始管理您的行程",
    signInToAccessTrips: "登录以访问您的行程",
    password: "密码",
    otpLogin: "信箱登入",
    register: "注册",
    emailConfirmationRequired: "需要验证邮箱",
    checkEmailForConfirmation: "请检查您的邮箱收件箱获取确认链接。您需要在继续前确认您的邮箱地址。",
    invalidEmail: "请输入有效的邮箱地址",
    confirmEmail: "确认邮箱地址",
    emailMismatch: "邮箱地址不匹配",
    verificationEmailSent: "请检查您的邮箱以找到验证码。",
    incorrectVerificationCode: "验证码不正确",
    loginSuccess: "登录成功！",
    passwordValidation: "密码必须包含至少一个大写字母、一个小写字母、一个数字、一个特殊字符，并且长度应在8到15个字符之间。",
    registrationPasswordSuccess: "注册成功并且密码已保存！",
    incorrectCredentials: "凭据不正确",
    otpRequestFailed: "请求验证码失败",
    unexpectedError: "发生意外错误",
    codeSent: "验证码已发送",
    checkEmailForCode: "请检查您的邮箱获取验证码。",
    sessionCreationFailed: "创建会话失败",
    enterVerificationCode: "输入发送到以下地址的验证码",
    enter6DigitCode: "输入6位数验证码",
    optionalPassword: "您可以选择为您的账户设置密码",
    passwordOptional: "密码（可选）",
    confirmPassword: "确认密码",
    registrationComplete: "注册完成！",
    accountCreatedRedirect: "您的账户已成功创建。您将很快被重定向...",
    validateEmail: "验证您的邮箱",
    signIn: "登录",
    sending: "发送中...",
    verifyEmail: "验证邮箱",
    backToEmail: "返回到邮箱",
    verifying: "验证中...",
    validateOTP: "验证OTP",
    noAccount: "没有账户？注册",
    travelAppLogo: "旅行应用",
    forgotPasswordInstructions: "请使用您的邮箱登录，然后更改您的密码",
    forgotPassword: "忘记密码",
    firstName: "名字",
    lastName: "姓氏",
    emailAddress: "電子郵箱地址",
    confirmEmailAddress: "确认電子郵箱地址",
    termsAgreementPart1: "創建賬戶即表示您同意我們的",
    termsOfService: "服務條款",
    privacyPolicy: "隱私政策",
    loginDescription: "追蹤航班、規劃行程並存取所有旅行資訊。一站式服務，讓您的旅程更加順暢。",
    loginAppDescription: "所有旅行資訊，一站式服務"
  },
  settings: {
    title: "設置",
    profile: {
      title: "我的資料",
      firstName: "名字",
      lastName: "姓氏",
      email: "電子郵箱",
      country: "國家",
      city: "城市",
      selectCountry: "選擇或輸入國家",
      enterCity: "輸入您的城市"
    },
    language: {
      title: "語言",
      preferred: "首選語言",
    },
    currency: {
      title: "貨幣",
      preferred: "首選貨幣"
    },
    notifications: {
      title: "通知",
      emailNotifications: "電子郵件通知",
      description: "接收重要更新的電子郵件通知",
    },
    consent: {
      title: "同意管理",
      open: "打開同意管理",
      description: "管理您的隱私和cookie偏好設置"
    },
    about: {
      title: "關於我們",
      tos: "服務條款",
      privacy: "隱私政策",
      faq: "常見問題",
    },
    contact: {
      title: "聯繫我們",
      email: "feedback@checkmytrip.com",
    },
    social: {
      title: "在社交媒體上關注我們",
    },
    profileUpdated: "個人資料已成功更新",
    updateError: "更新個人資料時出錯",
    changePassword: "更改密码",
    newPassword: "新密码",
    confirmPassword: "确认密码",
    updatePassword: "更新密码",
    passwordMismatch: "密码不匹配",
    passwordTooShort: "密码必须至少包含8个字符",
    passwordUpdated: "密码已成功更新",
    passwordUpdateError: "更新密码时出错",
    deleteAccount: "刪除帳戶",
    deleteAccountDescription: "永久刪除您的帳戶和所有相關數據",
    confirmDelete: "您確定嗎？",
    deleteWarning: "此操作無法撤銷。這將永久刪除您的帳戶並從我們的服務器中刪除所有數據。",
    confirmDeleteButton: "是的，刪除我的帳戶",
    accountDeleted: "您的帳戶已成功刪除。",
    deleteError: "刪除帳戶失敗",
    feedback: {
      title: "反馈",
      description: "我们重视您的反馈。通过分享您的想法帮助我们改进服务。",
      button: "提供反馈"
    }
  },
  index: {
    greeting: "您好，旅行者",
    greetingWithName: "您好，{{name}}",
    manageTrips: "管理您的行程",
    bookingRef: "預訂參考號",
    lastName: "姓氏",
    addTrip: "添加行程",
    timeline: "您的時間線",
    travelPlans: "您的旅行計劃",
    errorFetchingTrips: "請確保您已使用相應的姓名和電子郵件登錄帳戶。",
    viewUpcomingFlights: "查看即將到來的航班",
    welcome: {
      title: "歡迎開始您的旅程！",
      features: {
        tripManagement: {
          title: "行程管理",
          description: "將所有旅行細節保存在一處 - 航班、酒店和活動。"
        },
        tripAlerts: {
          title: "行程提醒",
          description: "收到關於您的航班、登機口變更和重要旅行更新的及時通知。"
        },
        offers: {
          title: "個性化優惠",
          description: "根據您的偏好和過往旅行獲取量身定制的旅行優惠。"
        },
        inspiration: {
          title: "旅行靈感",
          description: "發現新目的地並獲取個性化的冒險推薦"
        }
      },
      tips: {
        profile: "完善您的個人資料以獲取個性化推薦",
        addTrip: "點擊+按鈕開始規劃您的第一次旅行",
        notifications: "開啟通知以不錯過重要更新",
        dates: "在日曆中追蹤重要的旅行日期"
      },
      getStarted: "快速入門貼士",
      ready: "準備開始您的旅程了嗎？讓我們讓每次旅行都令人難忘！ ✈️"
    },
    importAdtdTripSuccess: "行程导入成功",
    importAdtdTripError: "無法將行程導入此帳戶",
    checkYourTrips: "在应用程序中查看您的行程"
  },
  tripCard: {
    daysLeft: "天",
    flightDetails: "航班详情",
    terminal: "航站楼",
    gate: "登机口",
    checkIn: "值机",
    flightInfo: "航班信息",
    airline: "航空公司",
    flight: "航班",
    departure: "出发",
    arrival: "到达",
    getFlightDetails: "航班详情",
    destinationInfo: "目的地信息",
    weather: "天气",
    activities: "推荐活动",
    food: "餐廳和咖啡館",
    tripDetails: "行程詳情",
    deleteConfirmation: {
      title: "您確定嗎？",
      description: "此操作無法撤銷。這將永久刪除您的行程。"
    },
    confirmDelete: "刪除行程？",
    deleteWarning: "此操作無法撤銷。這將永久刪除您前往 {{tripName}} 的行程並將其從您的帳戶中移除。",
    confirmDeleteButton: "是的，刪除行程",
    tripDeleted: "行程已成功刪除",
    deleteError: "刪除行程時出錯",
    recommendedActivities: "推薦活動在",
    back: "返回",
    checkStatus: "查看状态",
    status: "状态",
    scheduled: "计划",
    estimated: "估计",
    onSchedule: "准时",
    lastUpdated: "最后更新",
    noUpdates: "无可用更新",
    taxiTransfer: "预订行程",
    taxiTransferDesc: "預訂計程車接送服務到您的酒店或機場",
    taxiTransferComingSoon: "計程車接送服務即將推出",
    tripStatus: {
      ongoing: "進行中的旅程",
      upcoming: "即將到來的旅程",
      past: "過去的旅程"
    },
    hotel: "酒店",
    car: "汽車",
    activity: "活動",
    viewOnMap: "在地图上查看",
    direct: "直飞",
    today: "今天",
    dayAgo: "1 天前",
    daysAgo: "{{count}} 天前",
    remainingDay: "还剩 1 天",
    remainingDays: "还剩 {{count}} 天",
    carRental: "租車服務",
    carModel: "車型",
    pickupLocation: "取車地點",
    dropoffLocation: "還車地點",
    pickup: "取車",
    dropoff: "還車",
    confirmationNumber: "確認號碼",
    addToCalendar: "添加到日曆",
    notifications: "通知",
    notificationsDescription: "關於您旅程的重要通知",
    noNotifications: "暫無通知",
    notificationsOnMobile: "此功能目前僅在移動應用程序上可用。",
    economy: "經濟艙",
    loadingNotifications: "正在加載通知..."
  },
  newTrip: {
    title: "添加新行程",
    bookingReference: "预订参考号",
    bookingReferenceDesc: "输入您的6位预订参考号，并确保您的个人资料中的名字和姓氏与预订中使用的相同。",
    bookingRefPlaceholder: "参考号 (例如: ABC123)",
    bookingRefTooShort: "预订参考号必须至少包含6个字符",
    bookingRefTooLong: "预订参考号最多只能包含10个字符",
    lastNamePlaceholder: "姓氏",
    findBooking: "查找预订",
    gmailSync: "与Gmail同步",
    gmailSyncDesc: "允许我们扫描您的Gmail收件箱以查找旅行预订",
    connectGmail: "连接Gmail账户",
    emailForward: "转发预订邮件",
    emailForwardDesc: "转发您的预订确认邮件以添加您的行程",
    emailCopied: "邮箱地址已复制",
    emailCopiedDesc: "邮箱地址已复制到剪貼板",
    copyEmail: "复制邮箱地址",
    manual: "手动输入",
    manualDesc: "手动添加您的行程详情",
    startManual: "开始手动输入",
    bookingSubmitted: "预订已提交",
    processingBooking: "正在查找您的预订...",
    gmailConsent: "Gmail连接",
    gmailProcessing: "正在连接到您的Gmail账户...",
    manualEntry: "手动输入行程",
    manualEntryDesc: "通过自行添加航班和酒店详情来创建行程",
    drawer: {
      addTripDetails: "添加行程详情",
      tripInfo: "行程信息",
      tripName: "行程名称",
      tripType: "行程类型",
      selectTripType: "选择行程类型",
      leisure: "休闲",
      business: "商务",
      family: "家庭",
      bleisure: "商务休闲",
      travelers: "旅客人数",
      addFlight: "添加航班",
      flightNumber: "航班号 (例如: CA1234)",
      departureDate: "出发日期",
      addedFlights: "已添加航班",
      from: "出发地:",
      to: "目的地:",
      terminal: "航站楼:",
      departure: "出发:",
      arrival: "到达:",
      addHotel: "添加酒店",
      hotelName: "酒店名称",
      cityName: "城市名称",
      selectCheckInOut: "选择入住/退房日期",
      addedHotels: "已添加酒店",
      createTrip: "创建行程",
      adding: "添加中...",
      selectFlight: "選擇航班",
      confirmFlight: "確認航班",
      step1: "信息",
      step2: "航班",
      step3: "酒店",
      step4: "审核",
      next: "下一步",
      back: "返回",
      review: "审核",
      flightsStepEmpty: "至少添加一个航班到您的行程",
      flightsStepWithFlights: "您已添加 {{count}} 个航班",
      hotelsStepEmpty: "添加酒店到您的行程（可选）",
      hotelsStepWithHotels: "您已添加 {{count}} 家酒店",
      reviewTrip: "审核您的行程",
      reviewDescription: "在创建前检查您的行程详情",
      tripSummary: "行程摘要",
      flightsSummary: "航班",
      hotelsSummary: "酒店"
    },
    profileMismatch: "抱歉，您的個人資料信息與預訂不符。請前往個人資料並確保您的姓名與用於預訂的姓名相同。您也可以嘗試通過以下選項轉發您的預訂確認郵件或手動輸入行程來導入您的行程。"
  },
  weather: {
    in: "天气在",
    loading: "正在加载天气数据...",
    currentWeather: "当前天气",
    forecast: "预报",
    temperature: "温度",
    feelsLike: "体感温度",
    wind: "风力",
    humidity: "湿度",
    precipitation: "降水量",
    pressure: "气压",
    visibility: "能见度",
    uvIndex: "紫外线指数",
    sunrise: "日出",
    sunset: "日落",
    daily: "每日",
    hourly: "每小时",
    today: "今天",
    tomorrow: "明天",
    min: "最低",
    max: "最高"
  },
  discover: {
    title: "探索體驗",
    subtitle: "為您的下一次冒險尋找和探索活動",
    getInspired: "獲取靈感",
    searchFilters: "搜索過濾器",
    search: "搜索",
    city: "城市",
    enterCityName: "輸入城市名稱",
    priceRange: "價格範圍",
    min: "最低",
    max: "最高",
    radius: "半徑（公里）",
    enterRadius: "輸入半徑",
    searchButton: "搜索",
    categoryTypes: "類別",
    popularActivities: "熱門活動",
    searchPlaceholder: "搜索活動、地點或體驗...",
    allActivities: "所有活動",
    inspiration: {
      location: "位置",
      price: "價格範圍",
      bestTimeToVisit: "最佳訪問時間",
      howToGetThere: "如何到達"
    },
    categories: {
      tour: "導覽",
      adventure: "冒險",
      food: "美食與飲品",
      culture: "文化",
      sightseeing: "觀光",
      entertainment: "娛樂",
      nature: "自然",
      wellness: "健康",
      sport: "運動",
      workshop: "工作坊"
    }
  },
  sidebar: {
    assistant: "助手",
    myTrips: "我的旅行",
    discover: "探索",
    newTrip: "新旅程",
    profile: "个人资料"
  },
  errors: {
    configurationError: "配置错误",
    websiteNotConfigured: "网站未正确配置。"
  }
}
